import { Component, OnInit } from '@angular/core';
import {empty} from '../../functions';
import {ModalService} from '../../shared/services/modal.service';
import {ApiService} from '../../shared/services/api.service';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {Router} from '@angular/router';
import {LocaleService} from '../../shared/services/locale.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  accountTypes = [{
    value: 'Student',
    label: 'Student'
  }, {
    value: 'Teacher',
    label: 'Teacher'
  }];

  /**
   * Form data
   */
  formData = {
    accountType: 'Student',
  };

  /**
   * Constructor
   *
   * @param modal
   */
  constructor(private modal: ModalService,
              private api: ApiService,
              public locale: LocaleService,
              private authService: AuthenticationService,
              public router: Router) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {
    /*

    // Make sure a user can only access if it is authenticated but has no account yet
    this.authService.isAuthenticated$.subscribe( (authenticated) => {

      if (authenticated) {
        this.authService.profile$.subscribe( (profile) => {
          if (!empty(profile)) {
            this.router.navigateByUrl('/');
          }
        });
      }
      else {
        this.router.navigateByUrl('/');
      }
    });

     */
  }

  /**
   * Proceed to next step
   * @constructor
   */
  Next() {

    if (empty(this.formData.accountType)) {

      this.modal.Alert('Register', 'Please select an account type');
      return;
    }

    switch (this.formData.accountType.toLowerCase()) {

      case 'student':
        this.router.navigateByUrl('/student/registration');
        break;

      case 'teacher':
        this.router.navigateByUrl('/teacher/registration');
        break;
    }
  }

  /**
   * Register account
   *
   * AccountType is required to define user role
   *
   * @constructor
   */
  Register():any {

    if (empty(this.formData.accountType)) {

      this.modal.Alert('Register', 'Please select an account type');
      return false;
    }

    // Proceed to register account
    const params = {
      accountType: this.formData.accountType
    };
    this.api.setEndpoint('account/register/' + this.formData.accountType);

    this.api.POST(params).pipe(
      catchError(this.handleError)
    ).subscribe( (data) => {

      if (!empty(data)) {

        // Set the new profile data
       // this.authService.setProfileData(data);


      } else {
        this.modal.Alert('Register', 'Something went wrong, please try again');
      }

    });

  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }

}
